<template>
  <div class="health-service">
    <nav-bar show-home left-text :title="title"></nav-bar>
    <!-- banenr列表 -->
    <banner-list :banners="bannerList"></banner-list>
    <supplier-brand :brands="brands" />
    <div class="health-service-wrapper">
      <div class="title">{{columnTit}}</div>
      <div class="health-service-product" v-show="productList.length">
        <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <product-list :sku-list="productList" />
        </list>
      </div>
      <div class="no-data" v-show="noData && !productList.length">
        <p>暂无商品</p>
      </div>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import NavBar from '../../components/NavBar'
import BannerList from '../../components/RightsMall/BannerList'
import SupplierBrand from '../../components/RightsMall/SupplierBrand'
import ProductList from '../../components/ProductDoubleEach'
import api from '../../utils/api'
let flag = false
export default {
  name: 'healthservice',
  components: {
    NavBar,
    BannerList,
    SupplierBrand,
    List,
    ProductList
  },
  data () {
    return {
      cid: 0,
      componentId: null,
      loading: false,
      finished: false,
      pageNum: 1,
      totalCont: 0,
      bannerList: [],
      productList: [],
      brands: [],
      columnTit: '',
      noData: false
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    }
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      dutation: 30000
    })
    this.getBannerList()
    this.getbrands()
    this.getProductColumn()
  },
  methods: {

    /**
     * 分页加载
    */
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getProductList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 1000)
    },
    async getBannerList () {
      const data = await api.getLocationCodingHandler('healthservicehome-1')
      if (data) {
        this.bannerList = data
      }
    },

    /**
     * 获取供应商品牌
     */
    async getbrands () {
      const data = await api.getLocationCodingHandler('healthservicehome-2')
      if (data) {
        this.brands = data
      }
    },

    /**
     * 获取商品列表栏目id
     */
    async getProductColumn () {
      const data = await api.getLocationCodingHandler('healthservicehome-3')
      if (data) {
        this.columnTit = data[0].configer.title
        this.cid = data[0].configer.column
        await this.getProductList()
      }
      this.$toast.clear()
    },
    /**
     * 获取商品类表
    */
    async getProductList (pageNum) {
      const res = await this.$axios.get(
        `/api/goods/channelItems/${this.cid}/${pageNum || 1}`
      )
      if (res.status === 200) {
        const { code, data, msg, count } = res.data
        if (code === 0) {
          this.totalCont = count
          this.productList = [...this.productList, ...data]
        } else if (code === 9006) {
          this.finished = true
          if (this.pageNum === 1) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.health-service {
  // background-color: #fff;
}
.health-service-wrapper {
  .title {
    display: flex;
    align-items: center;
    margin: 0.3rem 0 0;
    padding-left: 0.2rem;
    font-size: @fz32;
    color: @base;
    font-weight:700;
    height: 0.97rem;
    background-color: #fff;
  }
}
.health-service-product {
  padding: 0.2rem;
  .sku-list {
    position: relative;
    padding-bottom: 0.25rem;
    border-bottom: 0.5px solid #d9d9d9;
    margin-bottom: 0.28rem;
    .sku-details {
      display: flex;
      .sku-img {
        width: 2.2rem;
        height: 2.2rem;
        background-color: #ddf1ff;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .sku-intro {
        margin-left: 0.32rem;
        width: 4.2rem;
        height: 2.1rem;
        .flex-column-between;
        .sku-title {
          font-size: @fz28;
          font-weight: bold;
          color: @base;
          .ellipsis;
        }
        .sku-desc {
          .ellipsis2;
          font-size: @fz24;
          color: @c80;
        }
        .sku-price {
          display: flex;
          align-items: baseline;
          font-size: @fz24;
          .price {
            color: #ff9600;
            em {
              font-size: 0.42rem;
              font-weight: 660;
            }
          }
          .rebate {
            margin-left: 0.2rem;
            color: #ff758f;
          }
        }
      }
    }
    .buy {
      position: absolute;
      right: 0.2rem;
      bottom: 0.25rem;
      width: 1.4rem;
      height: 0.68rem;
      background-color: #ff9600;
      border-radius: 30px;
      color: #fff;
      font-size: @fz28;
    }
  }
}
.no-data {
  text-align: center;
  padding: 1rem 0;
  font-size: @fz32;
}
</style>
